@if (!detachedMode) {
  <button class="relative" type="button" (click)="overlay.displayOverlay($event)">
    <ts-color-bubble size="lg" [hexColor]="value?.hex_value ?? fallbackColor" />
    <ts-icon
      class="absolute"
      icon="ts_palette"
      [ngStyle]="{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }"
      [color]="isContrastFromSelectColorLight ? 'white' : 'black'"
    />
  </button>
}

<ts-overlay overlay position="right" [transparentBackdrop]="true" #overlay>
  <div class="w-full grid grid-cols-4 items-center justify-center gap-4 p-4">
    @if (loading) {
      @for (skeleton of [1, 2, 3, 4, 6, 7, 8, 9]; track skeleton) {
        <ts-skeleton mode="circle" diameter="32" />
      }
    } @else {
      @for (color of colorOptions; track color.hex_value) {
        <div class="flex flex-row justify-center items-center relative w-fit-content">
          <button
            class="rounded-full focus:outline-none focus:ring-2"
            [attr.title]="color.label"
            [matTooltip]="color.label"
            [ngClass]="value?.id === color.id ? 'ring-2 ring-green-default' : ''"
            tabindex="0"
            (click)="selectColor(color)"
          >
            <ts-color-bubble size="lg" [hexColor]="color.hex_value" />
          </button>
          <!--    add a check mark to the selected bubble-->
          @if (value?.id === color.id) {
            <ts-icon
              class="absolute z-10 bg-white rounded-full"
              color="green"
              [ngStyle]="{ top: '-4px', left: '-18%' }"
              icon="check_circle"
            ></ts-icon>
          }
        </div>
      }

      @if (enableAdd) {
        <button
          class="relative transition-all flex flex-row items-center justify-center w-8 h-8 rounded-full cursor-pointer hover:bg-gray-200 active:bg-gray-300 hover:border-gray-500 focus:outline-none focus:ring-2"
          (click)="openColorPicker()"
        >
          <ts-icon class="block w-auto" icon="ts_plus" color="light-gray" />
          <input
            colorPicker
            cpAlphaChannel="disabled"
            cpOKButton="true"
            cpOKButtonText="Accept"
            cpOKButtonClass="bg-primary text-white px-2 py-1 rounded"
            cpCancelButton="true"
            cpCancelButtonClass="bg-white border px-2 py-1 rounded"
            class="w-0 absolute top-1/4 left-full"
            (colorPickerSelect)="onColorSelected($event)"
          />
        </button>
      }

      <button
        class="relative transition-all flex flex-row items-center justify-center w-8 h-8 rounded-full cursor-pointer hover:bg-gray-200 active:bg-gray-300 hover:border-gray-500 focus:outline-none focus:ring-2"
        (click)="selectColor(null)"
      >
        <ts-icon class="block w-auto" icon="undo" color="light-gray" />
      </button>
    }
  </div>
</ts-overlay>
